module.exports = __webpack_public_path__ + "static/media/template-homepage.315a2d63.jpg";